/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the custom hub method names which are used for client communication
 */
export class MessagingConstants {
    /**
     * Event name for staging counts update
     */
    static readonly staging_update_counts: string = 'stagingUpdateCounts';
    /**
     * Event name for notification
     */
    static readonly notification: string = 'notification';
    /**
     * Event name for cache invalidation
     */
    static readonly invalidate_cache: string = 'invalidateCache';
    /**
     * Event name for user logout
     */
    static readonly logout: string = 'logout';
}
